import routerOptions0 from "/home/circleci/project/node_modules/.pnpm/nuxt@3.16.2_@types+node@18.19.8_cac@7.0.0_db0@0.3.4_encoding@0.1.13_eslint@10.5.0_jiti@_e1f8dc1784592a518d888be9f9dda493/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/circleci/project/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}